var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":function($event){return _vm.$emit('add-improvement')}}},[_c('feather-icon',{attrs:{"size":"21","icon":"CheckCircleIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }